/* Eyeshells: device flags (iPad) for tablet-specific CSS hooks */
(function () {
  try {
    var ua = navigator.userAgent || '';
    // iPadOS 13+ may identify as Macintosh; touch-capable check catches it.
    var isIPad = /iPad/.test(ua) || (/Macintosh/.test(ua) && ('ontouchend' in document));
    if (isIPad) document.documentElement.classList.add('es-ipad');
  } catch (e) {}
})();

/**
 * ES: Unit conversion for specs ONLY (no正文污染)
 *
 * Goal:
 *  - 155 mm -> 155 mm / 6.1 in
 *  - 8 grams -> 8 grams / 0.3 ounces
 *
 * IMPORTANT:
 *  - Do NOT rely on changing product description templates.
 *  - Works even when number and unit are split across nodes:
 *      <span class="value">155</span>&nbsp;mm
 *  - PDP: only inside Details tab (#des) and only inside FRAME SIZE/spec list.
 *  - Quickview: only inside the quickview modal/spec container.
 */
(function () {
  'use strict';

  // ---- helpers ----
  function formatOneDecimal(n) {
    var s = n.toFixed(1);
    s = s.replace(/\.0+$/, '').replace(/(\.[0-9]*[1-9])0+$/, '$1');
    return s;
  }

  function textOf(el) {
    return ((el && el.textContent) ? el.textContent : '').replace(/\u00A0/g, ' ').trim();
  }

  function hasInches(text) {
    return /\/\s*\d+(?:\.\d+)?\s*in\b/i.test(text);
  }

  function hasOunces(text) {
    return /\/\s*\d+(?:\.\d+)?\s*ounce(s)?\b/i.test(text);
  }

  function getNumberFromEl(el) {
    // Prefer <span class="value">155</span>
    if (!el) return null;
    var v = el.querySelector ? el.querySelector('.value') : null;
    if (v && v.textContent) {
      var n = parseFloat(v.textContent.replace(/[^\d.]/g, ''));
      if (isFinite(n)) return n;
    }
    // Fallback: first number in text
    var m = textOf(el).match(/(\d+(?:\.\d+)?)/);
    if (m) {
      var n2 = parseFloat(m[1]);
      if (isFinite(n2)) return n2;
    }
    return null;
  }

function convertColorPrimary(colorPrimaryEl) {
  if (!colorPrimaryEl || colorPrimaryEl.nodeType !== 1) return;
  if (colorPrimaryEl.getAttribute('data-es-units-done') === '1') return;

  colorPrimaryEl.setAttribute('data-es-units-done', '1'); // 先标记

  var t = textOf(colorPrimaryEl);
  if (!t) return;
}


  function normalizeWeightLabel(li) {
    if (!li || li.nodeType !== 1) return;
    if (li.getAttribute('data-es-weight-label') === '1') return;

    // Replace "Frame Weight:" -> "Weight:" in the first text nodes of the LI
    var changed = false;
    var nodes = li.childNodes || [];
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n && n.nodeType === 3 && n.nodeValue) {
        var before = n.nodeValue;
        var after = before.replace(/\bFrame\s*Weight\s*:/i, 'Weight:');
        if (after !== before) {
          n.nodeValue = after;
          changed = true;
          break;
        }
      }
    }

    // Fallback: if label is wrapped in an element
    if (!changed) {
      var t = textOf(li);
      if (/\bFrame\s*Weight\s*:/i.test(t)) {
        try {
          li.innerHTML = li.innerHTML.replace(/\bFrame\s*Weight\s*:/i, 'Weight:');
        } catch (e) {}
      }
    }

    li.setAttribute('data-es-weight-label', '1');
  }

  function normalizeSectionHeadings(root) {
    if (!root || root.nodeType !== 1) return;

    // 1) SPECIFICATIONS -> Specifications
    var specHeads = root.querySelectorAll('.specification .h2, .specification h2, .specification .font-black');
    for (var i = 0; i < specHeads.length; i++) {
      var h = specHeads[i];
      if (!h || h.getAttribute('data-es-spec-head') === '1') continue;
      var t = textOf(h);
      if (t && t.toUpperCase() === 'SPECIFICATIONS') {
        h.textContent = 'Specifications';
      }
      h.setAttribute('data-es-spec-head', '1');
    }

    // 2) FRAME SIZE -> Frame Measurements
    // (Weight is not strictly a size, so this label is more accurate.)
    var fsHeads = root.querySelectorAll('.frame-size h2, .frame-size .h2, h2');
    for (var j = 0; j < fsHeads.length; j++) {
      var hh = fsHeads[j];
      if (!hh || hh.getAttribute('data-es-fs-head') === '1') continue;
      var tt = textOf(hh);
      if (tt && tt.toUpperCase() === 'FRAME SIZE') {
        hh.textContent = 'Frame Measurements';
      }
      hh.setAttribute('data-es-fs-head', '1');
    }
  }

  function asArray(nodeList) {
    var arr = [];
    if (!nodeList) return arr;
    for (var i = 0; i < nodeList.length; i++) arr.push(nodeList[i]);
    return arr;
  }

  // ---- Scoped processing ----
  // We only convert in the specs list items (FRAME SIZE block) to avoid正文污染.
  var SPEC_LI_SELECTOR = [
    'li.frame-width',
    'li.lens-width',
    'li.bridge',
    'li.temple-length',
    'li.lens-height',
    'li.frame-weight'
  ].join(',');

  function processWithin(root) {
    if (!root || root.nodeType !== 1) return;

    // Normalize headings first (scoped to the spec blocks only)
    normalizeSectionHeadings(root);

    // 1) Preferred: your template uses these LI classes
    var lis = asArray(root.querySelectorAll(SPEC_LI_SELECTOR));
    for (var i = 0; i < lis.length; i++) {
      var li = lis[i];
      if (li && li.matches && li.matches('li.frame-weight')) normalizeWeightLabel(li);
      var cp = li.querySelector ? li.querySelector('.color-primary') : null;
      if (cp) convertColorPrimary(cp);
    }

    // 2) Fallback: if classes are missing, still limit to frame-size area if present
    var frameSize = root.querySelector ? root.querySelector('.frame-size') : null;
    if (frameSize) {
      var wlis = asArray(frameSize.querySelectorAll('li.frame-weight'));
      for (var wi = 0; wi < wlis.length; wi++) normalizeWeightLabel(wlis[wi]);
      var cps = asArray(frameSize.querySelectorAll('.color-primary'));
      for (var j = 0; j < cps.length; j++) {
        var txt = textOf(cps[j]);
        if (/\bmm\b/i.test(txt) || /\bgrams?\b/i.test(txt)) convertColorPrimary(cps[j]);
      }
    }
  }

  function processPDP() {
    // Only Details tab content
    var detailsPanes = asArray(document.querySelectorAll('.tab-pd-details #des'));
    for (var i = 0; i < detailsPanes.length; i++) processWithin(detailsPanes[i]);
  }

  function processQuickview() {
    // Quickview varies: try common containers
    var qvRoots = asArray(document.querySelectorAll(
      '.quickview-product, #quickviewModal, #ModalQuickView, .modal.quickview, .modal.quickview-product'
    ));
    for (var i = 0; i < qvRoots.length; i++) {
      // Often injected into .des inside modal
      var des = qvRoots[i].querySelector ? qvRoots[i].querySelector('.des') : null;
      processWithin(des || qvRoots[i]);
    }
  }

  function processAll() {
    processPDP();
    processQuickview();
  }

  // ---- scheduling / observers ----
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      scheduled = false;
      processAll();
    }, 16);
  }

  function init() {
    processAll();

    // Content might render after tabs/modal injections
    setTimeout(processAll, 300);
    setTimeout(processAll, 1200);

    // Observe DOM changes (quickview injection, ajax, etc.)
    if (window.MutationObserver && document.body) {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            schedule();
            break;
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }

    // Bootstrap modal show event (best effort)
    document.addEventListener('shown.bs.modal', function () {
      setTimeout(processAll, 50);
    }, true);

    // Tab clicks (best effort)
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t) return;
      // If user clicks the tabs or quickview triggers, re-run
      var cls = (t.className || '');
      if (/underline_scale|tab_prod|quickview|quick-view|qv/i.test(cls)) {
        setTimeout(processAll, 50);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
